/* 
Handle key event for different browsers 
https://unixpapa.com/js/key.html
*/
export const getKeyForBrowser = (event) => {
  let key = event.which ? event.which : event.keyCode;
  if (!key) {
    if (event.charCode) {
      key = event.charCode;
    }
  }

  return key;
};
